import { observer } from "mobx-react";
import React from "react";
import { MaterialInstructions } from "../../../../adl-gen/kachemedia/specsheet/db";
import { CustomizedReactMarkdown } from "src/ui/components/shared/molecules/CustomizedReactMarkdown";
import {
  Table,
  TableCell,
  TableRow,
} from "src/ui/components/shared/atoms/table/table";
import { Box, Typography } from "@mui/material";

interface MaterialInstructionsDisplayModalContentProps {
  miProps: Omit<MaterialInstructions, "targeting" | "notes"> & {
    targeting?: string;
    notes?: string;
  };
  compact?: boolean;
  hideImages?: boolean;
}
/** Display only for Material Instructions */

export const MaterialInstructionsDisplayContent = observer(
  (props: MaterialInstructionsDisplayModalContentProps) => {
    const {
      miProps: { objectives, creativeRotation, messaging, targeting, notes },
      hideImages,
    } = props;

    const informationToRenderInTable = [
      { label: "Objectives", data: objectives },
      { label: "Creative", data: creativeRotation },
      { label: "Targeting", data: targeting },
      { label: "Messaging", data: messaging },
    ];

    const compact = props.compact ?? false;

    if (compact) {
      return (
        <div>
          {informationToRenderInTable.map((info) => {
            if (!info.data?.trim()) {
              return null;
            }
            return (
              <React.Fragment key={info.label}>
                <h3 style={{ fontSize: "1em" }}>{info.label}</h3>
                <p>{info.data}</p>
              </React.Fragment>
            );
          })}

          {notes && (
            <React.Fragment>
              <h3 style={{ fontSize: "1em" }}>Notes</h3>
              <CustomizedReactMarkdown source={notes} hideImages={hideImages} />
            </React.Fragment>
          )}
        </div>
      );
    }

    return (
      <div>
        <Table css={{ marginBottom: "16px" }}>
          {informationToRenderInTable.map((info) => {
            if (!info.data?.trim()) {
              return null;
            }
            return (
              <TableRow key={info.label}>
                <TableCell>
                  <b>{info.label}: </b>
                  {info.data}
                </TableCell>
              </TableRow>
            );
          })}
        </Table>
        {notes && (
          <React.Fragment>
            <h5 style={{ fontSize: "1em" }}>Notes</h5>
            <CustomizedReactMarkdown source={notes} hideImages={hideImages} />
          </React.Fragment>
        )}
      </div>
    );
  }
);

interface MaterialInstructionsModalHeaderProps {
  campaignTitle: string;
}

/** Material Instructions bookings modal header */
@observer
export class MaterialInstructionsModalHeader extends React.Component<MaterialInstructionsModalHeaderProps> {
  /** Renders the modal header */
  render() {
    return (
      <Box
        sx={(theme) => ({
          p: `${2 * theme.metrics.unit}px ${3 * theme.metrics.unit}px`,
          pb: 0,
        })}
      >
        <Typography noWrap fontSize={"12px"} mb={"4px"}>
          {this.props.campaignTitle}
        </Typography>
        <Typography
          component={"h6"}
          noWrap
          sx={{ fontSize: "1em" }}
          variant={"baseBold"}
        >
          Creative Instructions
        </Typography>
      </Box>
    );
  }
}
